// ==============================|| ROUTES TYPES  ||============================== //

// dispatcher routes
export enum DispatcherRoutes {
  ONLINE_DISPATCHING_PATH = '/:tenant/dispatcher/online-dispatching',
  ONLINE_DISPATCHING_BALANCING_GROUP_ID_PATH = '/:tenant/dispatcher/online-dispatching/balancingGroup/:balanceGroupId',
  ONLINE_DISPATCHING_DELIVERY_POINT_PATH = '/:tenant/dispatcher/online-dispatching/balancingGroup/:balanceGroupId/deliveryPoint/:deliveryPointId',
  ONLINE_DISPATCHING_DEVICE_PATH = '/:tenant/dispatcher/online-dispatching/balancingGroup/:balanceGroupId/deliveryPoint/:deliveryPointId/device/:deviceId',
  PRODUCTION_PLANNING_PATH = '/:tenant/dispatcher/production-planning/:businessDay?', // optional param
  CONSUMPTION_PLANNING_PATH = '/:tenant/dispatcher/consumption-planning/:businessDay?', // optional param
  OPERATION_CALENDAR_PATH = '/:tenant/dispatcher/operation-calendar',
  HX_DASHBOARD = '/:tenant/dispatcher/h-plus-x-si/balancingGroup/:balanceGroupId',
  RK_DASHBOARD = '/:tenant/dispatcher/rk-dashboard/:deliveryPointId'
}

// reporting routes
export enum ReportingRoutes {
  MARKET_IMBALANCE = '/:tenant/reporting/report-market-imbalance',
  BALANCING_GROUP = '/:tenant/reporting/report-balancing-group',
  DEVICE_PRODUCTION_PLAN = '/:tenant/reporting/report-device-production-plan',
  DELIVERY_POINT_PRODUCTION_PLAN = '/:tenant/reporting/report-delivery-point-production-plan',
  ECONOMIC_BENEFITS = '/:tenant/reporting/report-economic-benefits'
}

// eai routes
export enum EaiUsersRoutes {
  USER_LIST_PATH = '/:tenant/eai/user/list',
  USER_DETAIL_PATH = '/:tenant/eai/user/:userId/detail',
  USER_DETAIL_ASSIGNMENT_PATH = '/:tenant/eai/user/:userId/detail/:id',
  USER_ENABLE_PATH = '/:tenant/eai/user/:userId/enable',
  USER_CREATE_PATH = '/:tenant/eai/user/create',
  USER_RESET_PASSWORD_PATH = '/:tenant/eai/user/:userId/reset-password'
}

export enum EaiMemberAccountRoutes {
  ASSIGN_MEMBER_ACCOUNT_USER_PATH = '/:tenant/eai/ems-member-account/:id/assign-user',
  UNASSIGN_MEMBER_ACCOUNT_USER_PATH = '/:tenant/eai/ems-member-account/:id/unassign-user'
}

export enum EaiMemberAccountUserRoutes {
  DELETE_ROLE_MEMBER_ACCOUNT_USER_PATH = '/:tenant/eai/ems-member-account-user/:id/delete-user-role',
  ADD_ROLE_ACCOUNT_USER_PATH = '/:tenant/eai/ems-member-account-user/:id/add-user-role'
}

export enum EaiSubjectsRoutes {
  SUBJECT_LIST_PATH = '/:tenant/eai/subject/list',
  SUBJECT_DETAIL_PATH = '/:tenant/eai/subject/:id',
  SUBJECT_CREATE_PATH = '/:tenant/eai/subject/create',
  SUBJECT_ACCOUNT_CREATE_PATH = '/:tenant/eai/subject/:id/subject-account/create'
}

export enum EaiBalanceGroupRoutes {
  BALANCE_GROUP_LIST_PATH = '/:tenant/eai/balancing-group/list',
  BALANCE_GROUP_DETAIL_PATH = '/:tenant/eai/balancing-group/:balanceGroupId'
}

export enum EaiDeliveryPointsRoutes {
  DELIVERY_POINTS_LIST_PATH = '/:tenant/eai/delivery-point/list',
  DELIVERY_POINTS_DETAIL_PATH = '/:tenant/eai/delivery-point/:id',
  DELIVERY_POINTS_CREATE_PATH = '/:tenant/eai/delivery-point/create',
  DELIVERY_POINT_GDS_LIST_PATH = '/:tenant/eai/delivery-point/:id',
  DELIVERY_POINTS_DETAIL_PATH_WITH_GDS_ID = '/:tenant/eai/delivery-point/:id/gds/:gdsId'
}

export enum EaiDevicesRoutes {
  DEVICES_LIST_PATH = '/:tenant/eai/device/list',
  DEVICES_DETAIL_PATH = '/:tenant/eai/device/:id',
  DEVICES_CREATE_PATH = '/:tenant/eai/device/create',
  DEVICES_DELETE_PATH = '/:tenant/eai/device/:id/delete',
  DEVICES_CHARACTERISTIC_GROUP_CREATE_PATH = '/:tenant/eai/device/:id/characteristic-groups',
  DEVICES_CHARACTERISTIC_GROUP_DETAIL = '/:tenant/eai/device/:id/deviceGroup/:deviceGroupId'
}

export enum EaiDeliveryContractsRoutes {
  DELIVERY_CONTRACTS_LIST_PATH = '/:tenant/eai/delivery-contract/list',
  DELIVERY_CONTRACTS_DETAIL_PATH = '/:tenant/eai/delivery-contract/:id',
  DELIVERY_CONTRACTS_CREATE_PATH = '/:tenant/eai/delivery-contract/create'
}

export enum SystemRoutes {
  ACTIVITY_EVENTS = '/:tenant/system/activityEvents',
  ALARMS = '/:tenant/system/alarms'
}
